import * as types from './action-types'

export const listDeliveryTeams = () => ({
  type: types.DELIVERY_TEAMS_FETCH_BEGIN,
})
